import { get, post } from "api/axios-client";
import { SegmentComments } from "components/QueueBoard/models/workOrderTypes";

const controllerUrl = "api/MobileComment/";

export const SegmentMobileCommentAPI = {
  // Dummy async APIs
  //    addCommentAPI : async (comment: Partial<SegmentComments>) => {
  //     return {
  //       ...comment,
  //       id: Math.random().toString(),
  //       modifiedDate: new Date().toISOString(),
  //       commentHistory: [],
  //     }
  //   },

  addComment: async (
    param: Partial<SegmentComments>
  ): Promise<SegmentComments | null> => {
    try {
      const { data } = await post(`${controllerUrl}SaveMobileComment`, param);
      return data;
    } catch (error) {
      throw error;
    }
  },

  updateComment: async (
    comment: SegmentComments
  ): Promise<SegmentComments | null> => {
    comment.commentHistory = undefined;
    //const updatedData = { ...comment, modifiedDate: new Date().toISOString() };

    try {
      const { data } = await post(
        `${controllerUrl}UpdateMobileComment`,
        comment
      );
      return data.content;
    } catch (error) {
      throw error;
    }
  },

  deleteComment: async (id: number): Promise<boolean> => {
    try {
      const { data } = await get(
        `${controllerUrl}DeleteMobileComment?commentIdentity=${id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
};
